import { useMemo } from 'react'

import { TCartItem } from '@/entities/cart'

import { cartInfoGenerator } from '../lib/cart-info-generator'

type CartInfoSchemaScriptProps = {
	cartItems: TCartItem[]
	totalPrice: number
}

export const CartInfoSchemaScript = ({ cartItems = [], totalPrice = 0 }: CartInfoSchemaScriptProps) => {
	const data = useMemo(
		() =>
			JSON.stringify({
				totalPrice,
				products: cartInfoGenerator(cartItems)
			}),
		[cartItems, totalPrice]
	)

	return (
		<script id="mb-cart-json" type="application/json">
			{data}
		</script>
	)
}
